import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { Operator, QueryFilter } from '@/types';

/**
 * Risk Name field definition
 * Free-text input (no preset values)
 */
export const RiskName: SimpleFilterDefinition = {
  apiField: 'name',
  uiField: 'Name',
  inputType: 'text', // Text input, no dropdown
  operators: ['is', 'is not', 'contains', 'starts with', 'ends with'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    const operatorMap: Record<string, string> = {
      '=': 'is',
      '!=': 'is not',
      CONTAINS: 'contains',
      'STARTS WITH': 'starts with',
      'ENDS WITH': 'ends with',
    };

    return {
      field: 'Name',
      operator: operatorMap[queryFilter.operator] || queryFilter.operator,
      value: queryFilter.value as string | string[],
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    const operatorMap: Record<string, string> = {
      is: '=',
      'is not': '!=',
      contains: 'CONTAINS',
      'starts with': 'STARTS WITH',
      'ends with': 'ENDS WITH',
    };

    return {
      field: 'name',
      operator: (operatorMap[simpleFilter.operator] ||
        simpleFilter.operator) as Operator,
      value: simpleFilter.value,
    };
  },
};
